import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { playMouseClickSound } from "@/utils/audioManager"

const isEnabledButton = (element: Element | null): element is HTMLButtonElement => {
  return element instanceof HTMLButtonElement && !element.disabled
}

export const useGameButtonClickSound = () => {
  const { pathname } = useLocation()
  const isGameRoute = pathname.startsWith("/game/")

  useEffect(() => {
    if (!isGameRoute) return

    const handlePress = (event: PointerEvent) => {
      const button = (event.target as HTMLElement).closest("button")
      if (!isEnabledButton(button)) return
      playMouseClickSound()
    }

    // pointerdown fires on press (earlier than click), so button feedback feels instant.
    document.addEventListener("pointerdown", handlePress, true)
    return () => document.removeEventListener("pointerdown", handlePress, true)
  }, [isGameRoute])
}
